import { z } from 'zod';
// ── 카테고리 ──
export const SnapThemeCategorySchema = z.enum(['DOMESTIC', 'INTERNATIONAL', 'STUDIO', 'NATURE']);
export const SNAP_THEME_CATEGORY_LABELS = {
    DOMESTIC: '국내',
    INTERNATIONAL: '해외',
    STUDIO: '스튜디오',
    NATURE: '자연',
};
// ── 스냅 테마 ──
export const SnapThemeSchema = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    description: z.string().nullable(),
    category: SnapThemeCategorySchema,
    thumbnailUrl: z.string().nullable(),
    isActive: z.boolean(),
    sortOrder: z.number(),
    sceneCount: z.number().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const CreateSnapThemeSchema = z.object({
    name: z.string().min(1, '이름을 입력해주세요').max(255),
    slug: z.string().min(1, 'Slug를 입력해주세요').max(64).regex(/^[a-z0-9-]+$/, '영문 소문자, 숫자, 하이픈만 사용 가능합니다'),
    description: z.string().optional(),
    category: SnapThemeCategorySchema,
    thumbnailUrl: z.string().max(500).optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
// ── 스냅 씬 ──
export const SnapSceneSchema = z.object({
    id: z.string(),
    themeId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    referenceImageUrl: z.string().nullable(),
    promptText: z.string().nullable(),
    styleSlug: z.string().nullable(),
    poseSlug: z.string().nullable(),
    wardrobeSlug: z.string().nullable(),
    cameraSlug: z.string().nullable(),
    isRecommended: z.boolean(),
    isActive: z.boolean(),
    sortOrder: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const CreateSnapSceneSchema = z.object({
    name: z.string().min(1, '이름을 입력해주세요').max(255),
    description: z.string().optional(),
    referenceImageUrl: z.string().max(500).optional(),
    promptText: z.string().optional(),
    styleSlug: z.string().max(64).optional(),
    poseSlug: z.string().max(64).optional(),
    wardrobeSlug: z.string().max(64).optional(),
    cameraSlug: z.string().max(64).optional(),
    isRecommended: z.boolean().optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
});
// ── 스냅 생성 요청 (사용자 API) ──
export const SnapGenerateRequestSchema = z.object({
    themeId: z.string(),
    sceneIds: z.array(z.string()).min(5).max(30).refine((ids) => ids.length % 5 === 0, { message: '씬 수는 5의 배수여야 합니다' }),
    role: z.enum(['GROOM', 'BRIDE', 'COUPLE']),
    referencePhotoIds: z.array(z.string()).min(1),
    modelId: z.string().optional(),
    albumId: z.string().optional(),
    albumName: z.string().optional(),
});
//# sourceMappingURL=snap.js.map